import { render, staticRenderFns } from "./TahsilatForm.vue?vue&type=template&id=4f877ead"
import script from "./TahsilatForm.vue?vue&type=script&lang=ts"
export * from "./TahsilatForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports